import DividasStoreErrorCode from '../enums/StoreDividaErrorCode';

const dividasStoreErrorMsg: Record<DividasStoreErrorCode, string> = {
  [DividasStoreErrorCode.DIVIDA_ID_NAO_ENCONTRADA]: 'Dívida id não encontrada no store',
  [DividasStoreErrorCode.UPDATE_ID_NAO_COINCIDE]: 'Id informada é diferente da dívida a ser atualizada',
  [DividasStoreErrorCode.CREATE_ID_EXISTENTE]: 'Já existe dívida com o mesmo id',
  [DividasStoreErrorCode.OFERTA_NAO_ENCONTRADA]: 'A oferta não foi encontrada',
};

export default class StoreDividasError extends Error {
  constructor(errCode: DividasStoreErrorCode) {
    const errMsg = dividasStoreErrorMsg[errCode];
    super(errMsg);
    this.name = this.constructor.name;
  }
}
